<template>
  <g id="Dial_A-05">
    <path fill="#FFFFFF" stroke="#231F20" stroke-width="0.1" stroke-miterlimit="10" d="M118.8537,110.0092
		c0,25.8313-20.9404,46.7717-46.7717,46.7717s-46.7717-20.9404-46.7717-46.7717S46.2507,63.2375,72.082,63.2375
		S118.8537,84.1779,118.8537,110.0092L118.8537,110.0092z M72.082,107.7048c-1.2727,0-2.3044,1.0317-2.3044,2.3044
		s1.0317,2.3044,2.3044,2.3044s2.3044-1.0317,2.3044-2.3044l0,0C74.3864,108.7365,73.3547,107.7048,72.082,107.7048z
		 M104.8214,107.1748h-7.6536v5.6693h7.6536v-5.6696V107.1748z"/>
    <g id="Dial_ring_W">

      <linearGradient id="Dial_ring_1_A-05" gradientUnits="userSpaceOnUse" x1="95.4688" y1="454.705" x2="48.6952" y2="535.7192" gradientTransform="matrix(1 0 0 1 0 -385.203)">
        <stop  offset="0" style="stop-color:whitesmoke"/>
        <stop  offset="1" style="stop-color:#FFFFFF"/>
      </linearGradient>
      <path id="Dial_ring" fill="url(#Dial_ring_1_A-05)" stroke="#B3B4B7" stroke-width="0.0133" stroke-miterlimit="1" d="
			M118.8478,110.0092c-0.0001,25.828-20.9379,46.7658-46.7659,46.7657S25.3161,135.837,25.3162,110.009
			c0-25.828,20.9378-46.7657,46.7658-46.7657S118.8478,84.1811,118.8478,110.0092L118.8478,110.0092z M72.082,68.9119
			c-22.6974,0-41.0973,18.3999-41.0973,41.0973s18.3999,41.0973,41.0973,41.0973s41.0973-18.3999,41.0973-41.0973
			S94.7794,68.9119,72.082,68.9119L72.082,68.9119z"/>

      <circle id="Outer_shoulder" fill="none" stroke="#B3B4B7" stroke-width="0.0333" stroke-miterlimit="10" cx="72.082" cy="110.0092" r="46.7658"/>

      <circle id="Inner_shoulder" fill="none" stroke="#767779" stroke-width="0.0333" stroke-miterlimit="1" cx="72.082" cy="110.0092" r="41.0973"/>
    </g>
    <g id="Sec_v3_">
      <g id="Sec-Ticks">

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.3693" y1="64.8541" x2="67.6453" y2="67.4726"/>

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6805" y1="65.5974" x2="63.2281" y2="68.1719"/>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.0935" y1="66.8263" x2="58.9073" y2="69.3302"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1297" y1="153.1087" x2="85.3159" y2="150.6048"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6613" y1="68.527" x2="54.7329" y2="70.933"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5613" y1="151.4072" x2="89.4917" y2="149.0023"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.4496" y1="73.2683" x2="46.9965" y2="75.3986"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.7743" y1="146.666" x2="97.2268" y2="144.5351"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7602" y1="76.2564" x2="43.5219" y2="78.2131"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4649" y1="143.6766" x2="100.7026" y2="141.7215"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.4018" y1="79.6138" x2="40.3595" y2="81.3756"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8208" y1="140.3189" x2="103.865" y2="138.5565"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.4151" y1="83.3031" x2="37.544" y2="84.8514"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8101" y1="136.6288" x2="106.6786" y2="135.0813"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6719" y1="91.5158" x2="33.0775" y2="92.5871"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5514" y1="128.4172" x2="111.1464" y2="127.3452"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9711" y1="95.9487" x2="31.475" y2="96.7625"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2528" y1="123.9846" x2="112.7489" y2="123.1698"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7411" y1="100.5345" x2="30.318" y2="101.0817"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4814" y1="119.3976" x2="113.9053" y2="118.8494"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="26.9989" y1="105.2243" x2="29.6174" y2="105.4993"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2237" y1="114.7078" x2="114.6065" y2="114.4327"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="26.9989" y1="114.7068" x2="29.6174" y2="114.4321"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2237" y1="105.2243" x2="114.6065" y2="105.4993"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7411" y1="119.3966" x2="30.318" y2="118.8494"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4795" y1="100.5355" x2="113.9053" y2="101.0817"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9698" y1="123.9827" x2="31.4737" y2="123.1698"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2508" y1="95.9487" x2="112.7489" y2="96.7615"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6719" y1="128.4152" x2="33.0768" y2="127.3452"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5514" y1="91.5158" x2="111.1464" y2="92.5861"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.4132" y1="136.6282" x2="37.544" y2="135.0807"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8082" y1="83.3031" x2="106.6786" y2="84.8504"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.3999" y1="140.3189" x2="40.3575" y2="138.5565"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8208" y1="79.6128" x2="103.8631" y2="81.3746"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7583" y1="143.6753" x2="43.52" y2="141.7196"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4632" y1="76.2562" x2="100.7015" y2="78.2119"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.4481" y1="146.6642" x2="46.9957" y2="144.5334"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.7725" y1="73.2672" x2="97.225" y2="75.3964"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6598" y1="151.4055" x2="54.7315" y2="149.0006"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5614" y1="68.5258" x2="89.4898" y2="70.9308"/>
        </g>
        <g>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.0928" y1="153.107" x2="58.9066" y2="150.6031"/>

          <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1285" y1="66.8244" x2="85.3147" y2="69.328"/>
        </g>

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5427" y1="65.5954" x2="80.9946" y2="68.1703"/>

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8519" y1="64.8522" x2="76.5759" y2="67.4707"/>

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.3693" y1="155.1642" x2="67.6453" y2="152.5457"/>

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6805" y1="154.4209" x2="63.2281" y2="151.8464"/>

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5427" y1="154.4229" x2="80.9946" y2="151.848"/>

        <line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8519" y1="155.1661" x2="76.5759" y2="152.5476"/>
      </g>
      <g id="Indices">

        <rect x="70.0918" y="64.6442" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9505" height="2.6335"/>

        <rect x="70.0918" y="152.7422" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9505" height="2.6328"/>

        <rect x="26.7021" y="108.0342" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6321" height="3.9505"/>

        <rect x="114.7966" y="108.0342" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6341" height="3.9505"/>

        <rect x="48.7704" y="70.5441" transform="matrix(0.8659 -0.5002 0.5002 0.8659 -29.2286 34.6897)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6334" height="2.6327"/>

        <rect x="92.818" y="146.8405" transform="matrix(0.8662 -0.4997 0.4997 0.8662 -61.4389 66.8626)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.633" height="2.634"/>

        <rect x="32.647" y="86.6716" transform="matrix(0.4997 -0.8662 0.8662 0.4997 -59.2234 73.4401)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6335" height="2.6336"/>

        <rect x="108.9436" y="130.7185" transform="matrix(0.5006 -0.8657 0.8657 0.5006 -59.2359 161.3904)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6337" height="2.6337"/>

        <rect x="32.643" y="130.7128" transform="matrix(0.8662 -0.4996 0.4996 0.8662 -61.4227 34.627)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6333" height="2.6331"/>

        <rect x="108.9293" y="86.6664" transform="matrix(0.8661 -0.4998 0.4998 0.8661 -29.2168 66.8813)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6343" height="2.633"/>

        <rect x="48.7735" y="146.838" transform="matrix(0.4999 -0.8661 0.8661 0.4999 -103.2644 117.4753)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6325" height="2.633"/>

        <rect x="92.8171" y="70.5477" transform="matrix(0.5002 -0.8659 0.8659 0.5002 -15.1799 117.4289)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6341" height="2.6331"/>
      </g>
      <g>
        <path fill="#231F20" d="M63.8819,148.3478l-0.1114-0.1051c-0.058-0.0506-0.1056-0.1121-0.14-0.181
				c-0.0238-0.055-0.0294-0.1161-0.016-0.1745c0.0155-0.0862,0.0684-0.161,0.1445-0.2043c0.0821-0.0448,0.1781-0.0566,0.2686-0.0329
				c0.0963,0.0199,0.1842,0.0687,0.2519,0.14l-0.041,0.1908c-0.0549-0.0905-0.1437-0.1553-0.2467-0.18
				c-0.0475-0.0124-0.0977-0.0092-0.1432,0.0091c-0.0379,0.014-0.0658,0.0466-0.0739,0.0862
				c-0.0075,0.0367-0.0011,0.0749,0.0179,0.1071c0.0278,0.0465,0.0631,0.0882,0.1044,0.1233l0.112,0.1032
				c0.1142,0.0874,0.1702,0.2311,0.1452,0.3727c-0.0152,0.0875-0.0676,0.1641-0.1436,0.21
				c-0.0802,0.0458-0.1752,0.0584-0.2646,0.0352c-0.1148-0.0238-0.2183-0.0852-0.2942-0.1745l0.0459-0.2135
				c0.0489,0.12,0.1524,0.2093,0.2783,0.24c0.0472,0.0121,0.0972,0.0065,0.1406-0.0157c0.0394-0.0193,0.0675-0.0559,0.0761-0.0989
				C64.0085,148.5125,63.971,148.4337,63.8819,148.3478z"/>
        <path fill="#231F20" d="M65.9868,148.0373l0.1689,0.03l-0.69,1.1011l-0.0371-0.0068l-0.2142-1.03l-0.5624,0.8908l-0.0365-0.0065
				l-0.2636-1.2719l0.1705,0.0305l0.18,0.8727l0.4736-0.7555l0.16,0.0286l0.1832,0.8736L65.9868,148.0373z"/>
        <path fill="#231F20" d="M66.2631,148.0731l0.1695,0.0254l-0.1777,1.1873l-0.17-0.0257L66.2631,148.0731z"/>
        <path fill="#231F20" d="M66.8743,148.8647l-0.1188-0.096c-0.0618-0.0463-0.114-0.104-0.154-0.17
				c-0.028-0.0529-0.0382-0.1134-0.0289-0.1725c0.0085-0.0873,0.0553-0.1663,0.1279-0.2155
				c0.0783-0.0507,0.173-0.0699,0.2649-0.0537c0.0976,0.0125,0.1891,0.0543,0.2624,0.12l-0.0261,0.1934
				c-0.0617-0.0862-0.1553-0.1442-0.26-0.1611c-0.0484-0.0086-0.0983-0.0013-0.1422,0.0208
				c-0.0365,0.0169-0.0618,0.0513-0.0671,0.0911c-0.0045,0.0373,0.0049,0.075,0.0264,0.1058
				c0.0314,0.0442,0.0697,0.083,0.1135,0.1149l0.12,0.0941c0.1204,0.0782,0.1872,0.2171,0.1731,0.36
				c-0.0084,0.0882-0.0546,0.1684-0.1266,0.22c-0.0763,0.052-0.17,0.0721-0.261,0.056c-0.1162-0.0147-0.2241-0.0679-0.3066-0.1511
				l0.0286-0.2164c0.0583,0.1157,0.1684,0.1966,0.2962,0.2177c0.0481,0.0083,0.0975-0.0013,0.139-0.027
				c0.0378-0.0221,0.0631-0.0606,0.0683-0.1041C67.0133,149.0193,66.97,148.9434,66.8743,148.8647z"/>
        <path fill="#231F20" d="M67.6727,148.9623l-0.1207-0.0934c-0.0627-0.0448-0.1162-0.1013-0.1576-0.1663
				c-0.0289-0.0524-0.0403-0.1126-0.0325-0.1719c0.0069-0.0873,0.052-0.1671,0.1233-0.218c0.0773-0.0525,0.1717-0.0736,0.264-0.059
				c0.0978,0.0103,0.1902,0.0503,0.2646,0.1146l-0.0218,0.1937c-0.0637-0.0847-0.1586-0.1406-0.2636-0.1553
				c-0.0485-0.0074-0.098,0.0007-0.1416,0.0231c-0.0361,0.018-0.0606,0.053-0.0651,0.0931
				c-0.0035,0.0373,0.0065,0.0747,0.0283,0.1052c0.0325,0.0435,0.0719,0.0816,0.1165,0.1126l0.1218,0.0914
				c0.122,0.0759,0.1917,0.2134,0.1806,0.3567c-0.0067,0.0883-0.0514,0.1694-0.1224,0.2224
				c-0.0753,0.0538-0.1687,0.0757-0.26,0.0611c-0.1166-0.0124-0.2257-0.0633-0.31-0.1448l0.0245-0.2168
				c0.0606,0.1143,0.172,0.1929,0.3,0.2116c0.0484,0.007,0.0977-0.0037,0.1389-0.03c0.0371-0.0232,0.0614-0.0623,0.0658-0.1058
				C67.8146,149.114,67.7704,149.0395,67.6727,148.9623z"/>
        <path fill="#231F20" d="M77.2178,148.1763l0.1594-0.02l0.1459,1.1916l-0.1716,0.0212l-0.1132-0.9273l-0.31,0.5054l-0.0316,0.0039
				l-0.4267-0.4149l0.1133,0.9269l-0.17,0.0209l-0.1461-1.1913l0.1614-0.02l0.456,0.4406L77.2178,148.1763z"/>
        <path fill="#231F20" d="M77.9696,148.0594l0.12-0.0185l0.717,1.1105l-0.1741,0.0271l-0.2126-0.3272l-0.5061,0.0788
				l-0.0937,0.3743l-0.1745,0.0273L77.9696,148.0594z M78.3264,148.711l-0.2582-0.4l-0.1106,0.4569L78.3264,148.711z"/>
        <path fill="#231F20" d="M78.9382,149.126l-0.221-1.1782l0.3975-0.0746c0.1297-0.0306,0.2648-0.0303,0.3944,0.0007
				c0.1022,0.0304,0.1936,0.0896,0.263,0.1706c0.0721,0.0822,0.1204,0.1824,0.14,0.29c0.0149,0.0776,0.0138,0.1575-0.0033,0.2347
				c-0.0163,0.0773-0.0484,0.1503-0.0944,0.2145c-0.0465,0.0668-0.1064,0.1231-0.176,0.1653
				c-0.0364,0.0233-0.0753,0.0426-0.1159,0.0576c-0.0691,0.0211-0.1396,0.0374-0.2109,0.0488L78.9382,149.126z M79.1251,148.0269
				l-0.211,0.04l0.1651,0.8772l0.2158-0.04c0.0663-0.0107,0.1313-0.0288,0.1936-0.054c0.0388-0.0173,0.0753-0.0395,0.1084-0.0661
				c0.0281-0.0237,0.0529-0.0512,0.0736-0.0817c0.0678-0.1009,0.0913-0.2251,0.0651-0.3437
				c-0.0266-0.1644-0.148-0.2974-0.3093-0.3388c-0.0401-0.011-0.0815-0.0164-0.123-0.016
				C79.2435,148.007,79.1839,148.0147,79.1251,148.0269L79.1251,148.0269z"/>
        <path fill="#231F20" d="M79.9752,147.7056l0.665-0.1438l0.0325,0.1494l-0.4973,0.1074l0.0774,0.358l0.48-0.1041l0.0325,0.15
				l-0.48,0.1039l0.0788,0.3645l0.5132-0.111l0.0323,0.1494l-0.6809,0.1475L79.9752,147.7056z"/>
      </g>
    </g>
    <g id="Numerals">
      <g>
        <path fill="#231F20" d="M51.7649,76.6185h1.0286v7.185h-1.0286V76.6185z"/>
        <path fill="#231F20" d="M55.2408,76.6185h1.0287v7.185h-1.0287V76.6185z"/>
      </g>
      <g>
        <path fill="#231F20" d="M39.0083,89.6118h1.0285v7.185h-1.0285V89.6118z"/>
        <path fill="#231F20" d="M43.5138,89.5192c0.6931,0.0202,1.3196,0.4178,1.633,1.0363c0.8606,1.6583,0.8606,3.6317,0,5.29
				c-0.4796,0.9283-1.6209,1.292-2.5492,0.8124c-0.3414-0.1764-0.621-0.4525-0.8016-0.7917
				c-0.8508-1.6733-0.843-3.654,0.0207-5.3206C42.1534,89.9201,42.8034,89.5269,43.5138,89.5192z M43.5238,90.4965h-0.0514
				c-0.4327,0.0266-0.8051,0.3153-0.9387,0.7277c-0.2577,0.6244-0.3762,1.2975-0.3471,1.9724
				c-0.0303,0.6835,0.0856,1.3655,0.34,2.0006c0.1352,0.5184,0.665,0.829,1.1834,0.6938c0.3398-0.0886,0.6052-0.354,0.6938-0.6938
				c0.2562-0.624,0.3738-1.2961,0.3447-1.97c0.0273-0.6791-0.0857-1.3565-0.3319-1.99c-0.2213-0.4939-0.5189-0.7407-0.8926-0.7407
				H43.5238z"/>
      </g>
      <path fill="#231F20" d="M36.0012,113.5517l-0.6326-0.7457c0.5259-0.3314,0.9962-0.7436,1.3937-1.2215
			c0.3702-0.427,0.6424-0.93,0.7973-1.4736c-0.3459,0.2078-0.7436,0.313-1.147,0.3035c-0.5361,0.0054-1.0493-0.2171-1.4118-0.6121
			c-0.7999-0.8416-0.7828-2.1676,0.0386-2.9882c0.4038-0.409,0.958-0.634,1.5327-0.6223c0.6378-0.0181,1.2499,0.252,1.6664,0.7354
			c0.4447,0.5259,0.676,1.1994,0.6481,1.8876c-0.0203,0.9388-0.3017,1.8533-0.8127,2.6411
			C37.5643,112.3131,36.8527,113.0326,36.0012,113.5517z M37.7601,109.0874c0.0307-0.177,0.0514-0.3556,0.0618-0.5349
			c0.0153-0.3709-0.1085-0.7341-0.3473-1.0183c-0.2224-0.26-0.5503-0.4056-0.8923-0.3961
			c-0.3103-0.0091-0.6101,0.1133-0.8254,0.3369c-0.2185,0.2264-0.3363,0.5316-0.3266,0.8461
			c-0.002,0.3074,0.1271,0.6011,0.3549,0.8075c0.226,0.2222,0.5317,0.3447,0.8486,0.34
			C37.0396,109.4612,37.4332,109.328,37.7601,109.0874z"/>
      <path fill="#231F20" d="M41.1454,122.9197c0.2694-0.0006,0.5363,0.0515,0.7857,0.1533c0.2469,0.0989,0.4735,0.2425,0.6684,0.4234
			c0.1928,0.1788,0.3488,0.3937,0.4591,0.6324c0.1121,0.2411,0.1696,0.5041,0.1684,0.77c0.0057,0.5242-0.2134,1.0258-0.6019,1.3778
			c0.3057,0.2081,0.5632,0.4795,0.7549,0.7958c0.1668,0.2993,0.2513,0.6374,0.2449,0.98c0.0017,0.2924-0.0665,0.581-0.1988,0.8417
			c-0.1335,0.2629-0.3152,0.4983-0.5358,0.6939c-0.2309,0.2046-0.4971,0.3655-0.7857,0.4746
			c-0.3028,0.1162-0.6246,0.175-0.9489,0.1734c-0.3313,0.0029-0.6602-0.0559-0.97-0.1734
			c-0.2877-0.1086-0.5537-0.2675-0.7857-0.4694c-0.2216-0.1934-0.402-0.4294-0.5305-0.6939
			c-0.129-0.2636-0.1954-0.5534-0.194-0.8469c-0.0118-0.6146,0.2636-1.1995,0.7449-1.5819
			c0.0705-0.0676,0.1494-0.1259,0.2348-0.1734c-0.3807-0.366-0.5978-0.8699-0.6022-1.398c-0.0012-0.2659,0.0564-0.5289,0.1685-0.77
			c0.1083-0.2359,0.2607-0.4489,0.449-0.6275c0.1932-0.1806,0.418-0.3241,0.6631-0.4235
			C40.591,122.9721,40.867,122.9183,41.1454,122.9197z M41.1454,126.7463c-0.1841,0.0001-0.367,0.0311-0.5408,0.0918
			c-0.1687,0.0568-0.3259,0.1432-0.4643,0.2552c-0.1312,0.1072-0.2404,0.2388-0.3214,0.3876
			c-0.0818,0.1503-0.124,0.3189-0.1225,0.49c-0.0017,0.1705,0.0386,0.3388,0.1173,0.49c0.0788,0.1504,0.1863,0.2839,0.3164,0.3929
			c0.1372,0.1149,0.2947,0.203,0.4643,0.26c0.1806,0.0618,0.3704,0.0928,0.5613,0.0918c0.1824,0.0002,0.3635-0.0309,0.5355-0.0918
			c0.1669-0.0574,0.3224-0.1437,0.4593-0.2551c0.1313-0.1071,0.2404-0.2388,0.3214-0.3877c0.0827-0.1535,0.1248-0.3256,0.1224-0.5
			c0.0015-0.1711-0.0406-0.3397-0.1224-0.49c-0.0819-0.1497-0.1928-0.2815-0.3264-0.3876c-0.2824-0.2222-0.6307-0.3443-0.99-0.347
			L41.1454,126.7463z M41.9005,124.2463c-0.2002-0.1984-0.4734-0.3054-0.7551-0.2958c-0.1524-0.0021-0.3035,0.0273-0.4439,0.0865
			c-0.1263,0.0537-0.2408,0.1319-0.3368,0.23c-0.0891,0.0912-0.16,0.1985-0.2091,0.3161c-0.0471,0.1132-0.0714,0.2346-0.0714,0.3573
			c-0.0005,0.1336,0.0273,0.2657,0.0817,0.3877c0.0526,0.1198,0.1269,0.2289,0.2193,0.3216
			c0.0952,0.094,0.2078,0.1686,0.3316,0.2194c0.136,0.0556,0.2817,0.0832,0.4286,0.0813c0.1381,0.001,0.275-0.025,0.4031-0.0765
			c0.1245-0.05,0.2386-0.1227,0.3367-0.2142c0.0977-0.0904,0.176-0.1998,0.23-0.3215c0.0549-0.1254,0.0827-0.2609,0.0815-0.3978
			C42.1902,124.6797,42.0843,124.4313,41.9005,124.2463z"/>
      <path fill="#231F20" d="M51.9175,136.0736h4.65l-3.2514,7.2693l-0.92-0.3876l2.6276-5.8994h-3.1062
			C51.9175,137.0559,51.9175,136.0736,51.9175,136.0736z"/>
      <path fill="#231F20" d="M90.15,135.7208h3.1891v0.9156h-2.253v1.8155c0.0723-0.0068,0.1459-0.01,0.2214-0.01
			c0.634-0.0231,1.2515,0.2052,1.7179,0.6353c0.4466,0.4172,0.692,1.0064,0.6737,1.6173c0.023,0.6193-0.2192,1.219-0.6659,1.6486
			c-0.4681,0.4325-1.089,0.6609-1.7257,0.635c-0.5914-0.002-1.1736-0.1467-1.6971-0.4218v-1.0595
			c0.4454,0.3128,0.9728,0.4881,1.5168,0.5042c0.3968,0.0125,0.7843-0.1222,1.0877-0.3782
			c0.5115-0.4166,0.5884-1.1689,0.1718-1.6804c-0.0616-0.0756-0.1322-0.1434-0.2102-0.2018
			c-0.341-0.2628-0.763-0.3983-1.1932-0.3831c-0.2818-0.0183-0.5644,0.0166-0.8333,0.1028L90.15,135.7208z"/>
      <path fill="#231F20" d="M104.686,126.3177v1.1021h1.0608v1.03h-1.0611v1.7449h-1.0207v-1.7449h-2.9382l2.7548-5.49h1.1529
			l-2.2445,4.4591h1.2752v-1.1021L104.686,126.3177z"/>
      <path fill="#231F20" d="M102.8256,95.5738h2.7353v0.9925h-4.547v-0.0719l0.4323-0.5092c0.6757-0.8367,1.2132-1.5465,1.6124-2.1293
			c0.3019-0.4148,0.5637-0.8574,0.7818-1.3218c0.1179-0.2802,0.1798-0.5807,0.1823-0.8846
			c0.0171-0.3574-0.1065-0.7074-0.3444-0.9747c-0.238-0.2485-0.5714-0.3825-0.9152-0.3676c-0.302,0.004-0.5969,0.0921-0.8515,0.2545
			c-0.2967,0.1861-0.5529,0.4302-0.7532,0.7175v-1.3065c0.4774-0.4244,1.0892-0.6666,1.7277-0.6839
			c0.5822-0.0184,1.1451,0.2094,1.5506,0.6275c0.4101,0.4275,0.6301,1.0025,0.61,1.5945c-0.0042,0.3136-0.0553,0.6249-0.1517,0.9234
			c-0.1341,0.397-0.3145,0.7768-0.5377,1.1315c-0.3948,0.6127-0.8329,1.1963-1.3111,1.7464L102.8256,95.5738z"/>
      <path fill="#231F20" d="M90.8889,76.6185h1.0292v7.1851h-1.0292V76.6185z"/>
      <g>
        <path fill="#231F20" d="M68.9782,71.7833h1.0286v7.185h-1.0286V71.7833z"/>
        <path fill="#231F20" d="M72.981,77.9757h2.7346v0.9926h-4.5464v-0.072l0.4321-0.5092c0.6753-0.8366,1.2126-1.5464,1.6121-2.1293
				c0.3021-0.4147,0.5638-0.8573,0.7818-1.3217c0.1181-0.2801,0.1802-0.5807,0.1829-0.8847c0.017-0.3575-0.1069-0.7074-0.345-0.9746
				c-0.2378-0.2488-0.5715-0.3828-0.9153-0.3677c-0.3018,0.0041-0.5966,0.0922-0.8511,0.2545
				c-0.2968,0.1861-0.5531,0.4301-0.7535,0.7175v-1.3064c0.4776-0.4244,1.0896-0.6667,1.7283-0.684
				c0.5822-0.0184,1.1451,0.2094,1.5506,0.6275c0.4099,0.4275,0.6296,1.0026,0.6093,1.5945
				c-0.0042,0.3136-0.0553,0.6249-0.1517,0.9234c-0.1335,0.3972-0.3137,0.777-0.537,1.1316
				c-0.395,0.6125-0.8331,1.1961-1.311,1.7463L72.981,77.9757z"/>
      </g>
      <path fill="#231F20" d="M72.7277,140.9692l0.1022-0.072l0.6224,0.7815c-0.5079,0.3198-0.9676,0.7104-1.3651,1.16
			c-0.3708,0.4349-0.6545,0.937-0.8358,1.479c0.3498-0.1877,0.7397-0.2883,1.1367-0.2933c0.5402-0.0108,1.0596,0.208,1.4293,0.6019
			c0.3849,0.3935,0.5945,0.9257,0.5814,1.476c0.0104,0.575-0.2188,1.1283-0.6328,1.5275c-0.4046,0.4113-0.9605,0.6382-1.5374,0.6275
			c-0.6256,0.0218-1.2275-0.24-1.6381-0.7125c-0.4331-0.522-0.6559-1.1868-0.6248-1.8643c0.0022-0.5881,0.1111-1.1708,0.3214-1.72
			c0.2202-0.5813,0.5328-1.1233,0.9257-1.6049C71.6503,141.8248,72.1603,141.3581,72.7277,140.9692z M71.0302,145.382
			c-0.0287,0.1785-0.0424,0.3592-0.041,0.54c-0.0142,0.3653,0.1118,0.7222,0.3522,0.9976c0.228,0.2578,0.5587,0.401,0.9027,0.3909
			c0.3068,0.0092,0.6031-0.1123,0.815-0.3343c0.2159-0.2267,0.3317-0.5305,0.3216-0.8433c0.0123-0.3166-0.1125-0.6231-0.3425-0.841
			c-0.2469-0.2213-0.571-0.3367-0.9022-0.3213c-0.1778-0.0025-0.3547,0.0271-0.522,0.0873
			C71.4078,145.1435,71.2119,145.2522,71.0302,145.382L71.0302,145.382z"/>
    </g>
    <g id="S_Logo">
      <g id="Printed">
        <path fill="#231F20" d="M66.47,93.0534c0.8578,0.0622,1.069,0.17,1.069,0.8338c0,0.48,0.0186,0.95-1.2539,0.95
				c-0.7386,0-1.2285-0.0153-1.2285-0.9652h0.7409c0,0.3008,0.1081,0.3327,0.4876,0.3327c0.3627,0,0.4815-0.0241,0.4815-0.2666
				c0-0.2518-0.0427-0.2476-0.4053-0.2707l-0.17-0.0112c-0.7139-0.05-1.1315-0.0466-1.1315-0.8768s0.4674-0.8828,1.2252-0.8828
				c0.6315,0,1.1722,0.01,1.1722,0.81v0.12h-0.74c0-0.2972-0.1237-0.2972-0.4323-0.2972c-0.4179,0-0.4535,0.085-0.4535,0.2464
				c0,0.2324,0.1117,0.24,0.3178,0.2546L66.47,93.0534z"/>
        <path fill="#231F20" d="M71.3538,91.9178h0.7754l-0.64,2.8961H70.372l-0.3938-1.8145h-0.03l-0.4219,1.8145h-1.1028l-0.625-2.8961
				h0.7822l0.4173,2.2324h0.027l0.5446-2.2324h0.8024l0.52,2.2324h0.0244L71.3538,91.9178z"/>
        <path fill="#231F20" d="M73.2623,94.8139h-0.7741v-2.8961h0.7741V94.8139z"/>
        <path fill="#231F20" d="M75.2096,93.0534c0.8581,0.0622,1.0693,0.17,1.0693,0.8338c0,0.48,0.0209,0.95-1.2529,0.95
				c-0.7379,0-1.23-0.0153-1.23-0.9652h0.7425c0,0.3008,0.1071,0.3327,0.487,0.3327c0.3627,0,0.4834-0.0241,0.4834-0.2666
				c0-0.2518-0.0433-0.2476-0.4078-0.2707l-0.1693-0.0112c-0.7139-0.05-1.13-0.0466-1.13-0.8768s0.4659-0.8828,1.224-0.8828
				c0.6316,0,1.1726,0.01,1.1726,0.81v0.12h-0.741c0-0.2972-0.1243-0.2972-0.4316-0.2972c-0.418,0-0.4531,0.085-0.4531,0.2464
				c0,0.2324,0.1126,0.24,0.3174,0.2546L75.2096,93.0534z"/>
        <path fill="#231F20" d="M78.1292,93.0534c0.8568,0.0622,1.0687,0.17,1.0687,0.8338c0,0.48,0.02,0.95-1.2543,0.95
				c-0.7366,0-1.2271-0.0153-1.2271-0.9652h0.74c0,0.3008,0.1093,0.3327,0.4869,0.3327c0.3627,0,0.4828-0.0241,0.4828-0.2666
				c0-0.2518-0.042-0.2476-0.4046-0.2707l-0.1712-0.0112c-0.7133-0.05-1.13-0.0466-1.13-0.8768s0.4677-0.8828,1.2235-0.8828
				c0.6342,0,1.1739,0.01,1.1739,0.81v0.12h-0.7416c0-0.2972-0.1236-0.2972-0.4323-0.2972c-0.4159,0-0.4508,0.085-0.4508,0.2464
				c0,0.2324,0.1117,0.24,0.3145,0.2546L78.1292,93.0534z"/>
        <path fill="#231F20" d="M65.3779,98.2852v-2.83h1.5937c0.3549-0.0415,0.7123,0.0542,0.9991,0.2674
				c0.2109,0.2975,0.3046,0.6624,0.263,1.0247c0.0423,0.4238-0.039,0.8508-0.2341,1.2294c-0.2459,0.2406-0.589,0.3545-0.93,0.3086
				L65.3779,98.2852z M65.7662,98.0152h1.1221c0.2818,0.0388,0.5676-0.0339,0.7965-0.2027
				c0.1519-0.2763,0.2138-0.5931,0.1771-0.9062c0.0353-0.3333-0.0177-0.67-0.1536-0.9764
				c-0.1038-0.1375-0.3506-0.2054-0.7419-0.2054h-1.2L65.7662,98.0152z"/>
        <path fill="#231F20" d="M69.2068,95.7243v0.9645h1.7471v0.2689h-1.7471v1.0573h1.8233v0.27H68.818v-2.83h2.2116v0.2692
				L69.2068,95.7243z"/>
        <path fill="#231F20" d="M72.122,95.4551v2.5334h1.7692v0.2967h-2.1569v-2.83L72.122,95.4551z"/>
        <path fill="#231F20" d="M75.1276,95.7516v2.5336h-0.3887v-2.5336h-1.1208v-0.2965h2.6205v0.2965H75.1276z"/>
        <path fill="#231F20" d="M78.4931,97.6859h-1.7428l-0.2637,0.5993h-0.41l1.26-2.83h0.5449l1.2842,2.83h-0.4059L78.4931,97.6859z
				 M78.3795,97.4452l-0.7623-1.7295l-0.7553,1.7295H78.3795z"/>
      </g>
      <g id="Logo">
        <path fill="none" d="M76.1168,88.7598c-0.0714-0.1892-0.2071-0.5209-0.2725-0.6763c-0.6621-1.5546-1.5182-3.0193-2.5479-4.3591
				c-0.0482-0.0636-0.14-0.1805-0.2252-0.2879c-0.0433-0.0544-0.0841-0.1057-0.1208-0.1472
				c-0.0274-0.0365-0.0571-0.0711-0.0889-0.1038c-0.3346-0.3159-0.8371-0.3744-1.2353-0.1437
				c-0.0636,0.0365-0.1226,0.0805-0.1758,0.1309c-0.019,0.0152-0.0363,0.0324-0.0517,0.0512
				c-0.1068,0.1231-0.3422,0.4334-0.4161,0.5295c-0.5323,0.6911-1.0177,1.4172-1.4528,2.1733
				c-0.4339,0.751-0.8181,1.5297-1.15,2.3311c-0.0258,0.0628-0.08,0.1909-0.1289,0.3044c-0.0241,0.0568-0.0482,0.1108-0.0644,0.1513
				c-0.0192,0.0448-0.028,0.0661-0.0352,0.0858c-0.0456,0.1177-0.0689,0.2428-0.0686,0.369
				c0.0002,0.4565,0.2976,0.8596,0.7337,0.9945c0.0801,0.0233,0.1627,0.0374,0.246,0.042c1.015,0.1615,2.0413,0.2414,3.069,0.2389
				c0.6785,0.0004,1.3565-0.0334,2.0316-0.1014c0.194-0.02,0.79-0.092,1.2158-0.1607c0.2858-0.0571,0.5315-0.2382,0.6707-0.4943
				c0.0185-0.0334,0.0272-0.0532,0.0306-0.061l0.0016-0.0008V89.623l0.0019-0.0027c0.0052-0.01,0.0136-0.0275,0.0257-0.0541
				c0.0572-0.1327,0.087-0.2755,0.0876-0.42c0.0003-0.0779-0.009-0.1555-0.0277-0.2311
				C76.1551,88.8623,76.1376,88.8104,76.1168,88.7598z M75.6574,89.3685l-0.0016,0.0024v0.0026l-0.014,0.0287l-0.0028,0.0083
				l-0.0151,0.03c-0.0656,0.1289-0.1847,0.2223-0.3255,0.2554c-0.4063,0.0661-1.0049,0.1376-1.1842,0.1565
				c-0.6589,0.0671-1.3209,0.1005-1.9832,0.1c-1.006,0.0022-2.0106-0.076-3.0042-0.2339l-0.0124-0.0034h-0.0157
				c-0.0467-0.0015-0.093-0.009-0.1377-0.0224c-0.2294-0.0715-0.3859-0.2838-0.3863-0.5241
				c-0.0003-0.0659,0.0118-0.1314,0.0358-0.1928v-0.0009c0.0189-0.0438,0.1712-0.3994,0.2253-0.5295
				c0.6505-1.5678,1.5032-3.0439,2.5364-4.3906c0.0419-0.0566,0.1393-0.1822,0.2311-0.2993c0.0449-0.0577,0.09-0.1135,0.123-0.1555
				c0.0193-0.0224,0.032-0.04,0.044-0.0526l0.01-0.011c0.0287-0.026,0.0599-0.049,0.0932-0.0686
				c0.209-0.1201,0.4718-0.0902,0.6484,0.0738c0.015,0.0146,0.0961,0.1143,0.1722,0.2106c0.0817,0.1031,0.168,0.214,0.2142,0.2723
				c1.0045,1.3062,1.8394,2.7345,2.4845,4.2507c0.0413,0.0981,0.1152,0.2795,0.1806,0.4418
				c0.0326,0.0818,0.0632,0.1593,0.0846,0.2187c0.0114,0.0291,0.02,0.0548,0.027,0.0719l0.0065,0.0208v0.0018
				c0.0089,0.0383,0.0136,0.0774,0.014,0.1167C75.7047,89.2232,75.6883,89.2986,75.6574,89.3685L75.6574,89.3685z"/>
        <path fill="#231F20" d="M76.3068,88.8846c-0.0159-0.0587-0.0351-0.1164-0.0576-0.1729
				c-0.0726-0.1941-0.2089-0.5254-0.2738-0.6836c-0.3212-0.7526-0.6875-1.4851-1.097-2.1935
				c-0.4406-0.7641-0.932-1.4977-1.4707-2.1961c-0.0492-0.0645-0.1393-0.1817-0.2281-0.29c-0.0408-0.0542-0.0841-0.1064-0.12-0.15
				c-0.0308-0.0406-0.0646-0.0788-0.1012-0.1142c-0.2194-0.2075-0.5099-0.3232-0.8119-0.3232h-0.0016
				c-0.2071,0.0004-0.4105,0.0549-0.59,0.1582c-0.0715,0.0423-0.1385,0.0918-0.2,0.1476l-0.108,0.1l0.0078,0.01
				c-0.1224,0.1476-0.3174,0.4039-0.3848,0.4907c-1.0684,1.3909-1.9493,2.9162-2.62,4.5368c-0.026,0.0612-0.08,0.1891-0.1285,0.3026
				c-0.0248,0.0562-0.0476,0.11-0.0655,0.1513c-0.0173,0.0432-0.0277,0.0663-0.0378,0.0894
				c-0.2314,0.611,0.0763,1.2939,0.6873,1.5253c0.0229,0.0087,0.0461,0.0166,0.0695,0.0239
				c0.0882,0.0263,0.1791,0.0427,0.2709,0.049c1.0203,0.1607,2.0517,0.2405,3.0846,0.2389
				c0.6838,0.0005,1.3671-0.0343,2.0473-0.1042c0.1962-0.0195,0.7907-0.0909,1.2232-0.1614
				c0.3276-0.0625,0.6099-0.2685,0.7693-0.5614c0.012-0.0213,0.02-0.0378,0.0257-0.05l0.0068-0.0147l0.0016-0.0052l0.0036-0.0032
				v-0.0036l0.002-0.0024c0.0099-0.019,0.0187-0.0386,0.0263-0.0586c0.0668-0.149,0.1012-0.3104,0.101-0.4737
				C76.3374,89.0582,76.3272,88.9704,76.3068,88.8846z M76.1092,89.5662c-0.0121,0.0266-0.02,0.044-0.0257,0.0541l-0.0019,0.0027
				v0.0025L76.08,89.6263c-0.0034,0.0078-0.0121,0.0276-0.0306,0.061c-0.1392,0.2561-0.3849,0.4372-0.6707,0.4943
				c-0.4257,0.0687-1.0218,0.14-1.2158,0.1607c-0.6751,0.068-1.3531,0.1018-2.0316,0.1014c-1.0277,0.0025-2.054-0.0774-3.069-0.2389
				c-0.0833-0.0046-0.1659-0.0187-0.246-0.042c-0.4361-0.1349-0.7335-0.538-0.7337-0.9945c-0.0003-0.1262,0.023-0.2513,0.0686-0.369
				c0.0072-0.02,0.016-0.041,0.0352-0.0858c0.0162-0.04,0.04-0.0945,0.0644-0.1513c0.0492-0.1135,0.1031-0.2416,0.1289-0.3044
				c0.3319-0.8014,0.7161-1.5801,1.15-2.3311c0.4351-0.7561,0.9205-1.4822,1.4528-2.1733c0.0739-0.0961,0.3093-0.4064,0.4161-0.5295
				c0.0154-0.0188,0.0327-0.036,0.0517-0.0512c0.0532-0.0504,0.1122-0.0944,0.1758-0.1309
				c0.3982-0.2307,0.9007-0.1722,1.2353,0.1437c0.0318,0.0327,0.0615,0.0673,0.0889,0.1038
				c0.0367,0.0415,0.0775,0.0928,0.1208,0.1472c0.0852,0.1074,0.177,0.2243,0.2252,0.2879
				c1.0297,1.3398,1.8858,2.8045,2.5479,4.3591c0.0654,0.1554,0.2011,0.4871,0.2725,0.6763c0.0206,0.0507,0.038,0.1027,0.052,0.1557
				c0.0187,0.0756,0.028,0.1532,0.0277,0.2311c-0.0005,0.1443-0.0303,0.2871-0.0874,0.4196H76.1092z M75.6912,89.0299
				c0.0089,0.0383,0.0136,0.0774,0.014,0.1167c-0.0006,0.0764-0.0168,0.1519-0.0475,0.2219l-0.0016,0.0024v0.0026l-0.014,0.0287
				l-0.0028,0.0083l-0.0151,0.03c-0.0656,0.1289-0.1847,0.2223-0.3255,0.2554c-0.4063,0.0661-1.0049,0.1376-1.1842,0.1565
				c-0.6589,0.0671-1.3209,0.1005-1.9832,0.1c-1.0061,0.0022-2.0108-0.076-3.0045-0.2339l-0.0124-0.0034h-0.0157
				c-0.0467-0.0015-0.093-0.009-0.1377-0.0224c-0.2294-0.0715-0.3859-0.2838-0.3863-0.5241
				c-0.0003-0.0659,0.0118-0.1314,0.0358-0.1928v-0.0009c0.0189-0.0438,0.1712-0.3994,0.2253-0.5295
				c0.6505-1.5678,1.5032-3.0439,2.5364-4.3906c0.0419-0.0566,0.1393-0.1822,0.2311-0.2993c0.0449-0.0577,0.09-0.1135,0.123-0.1555
				c0.0193-0.0224,0.032-0.04,0.044-0.0526l0.01-0.011c0.0287-0.026,0.0599-0.049,0.0932-0.0686
				c0.209-0.1201,0.4718-0.0902,0.6484,0.0738c0.015,0.0146,0.0961,0.1143,0.1722,0.2106c0.0817,0.1031,0.168,0.214,0.2142,0.2723
				c1.0045,1.3062,1.8394,2.7345,2.4845,4.2507c0.0413,0.0981,0.1152,0.2795,0.1806,0.4418
				c0.0326,0.0818,0.0632,0.1593,0.0846,0.2187c0.0114,0.0291,0.02,0.0548,0.027,0.0719l0.0065,0.0208L75.6912,89.0299z"/>
        <polygon fill="#FFFFFF" points="74.1258,86.6975 72.7308,86.6975 72.7308,85.2815 71.5738,85.2815 71.5738,86.6975
				70.1568,86.6975 70.1568,87.8545 71.5738,87.8545 71.5738,89.2495 72.7308,89.2495 72.7308,87.8545 74.1258,87.8545 			"/>
      </g>
    </g>
    <g id="_3H_Date_window">
      <g id="_515_3H_Window">
        <polygon fill="#E6E7E7" points="97.1678,107.1745 96.3178,106.3245 105.6708,106.3245 104.8218,107.1745 			"/>
        <polygon fill="#D0D2D3" points="97.1678,112.8435 96.3178,113.6955 96.3178,106.3245 97.1678,107.1745 			"/>
        <polygon fill="#FFFFFF" points="104.8218,112.8435 105.6708,113.6955 96.3178,113.6955 97.1678,112.8435 			"/>
        <polygon fill="#FFFFFF" points="104.8218,107.1745 105.6708,106.3245 105.6708,113.6955 104.8218,112.8435 			"/>
      </g>
      <g>
        <rect x="97.0145" y="107.2441" fill="none" width="7.9602" height="5.5273"/>
      </g>
    </g>
    <g>
      <g>
        <path fill="#231F20" d="M71.3996,128.3185h0.9v0.3525h-0.9V128.3185z"/>
        <path fill="#231F20" d="M73.3873,126.7579c0.2434,0.007,0.4635,0.1466,0.5735,0.3639c0.3024,0.5826,0.3024,1.2759,0,1.8585
				c-0.1684,0.3261-0.5693,0.454-0.8955,0.2856c-0.1201-0.062-0.2184-0.1591-0.2818-0.2785
				c-0.1604-0.2843-0.2373-0.608-0.2219-0.9341c-0.0143-0.3272,0.0653-0.6517,0.2294-0.9351
				C72.9094,126.8985,73.1377,126.7605,73.3873,126.7579z M73.3908,127.101h-0.0182c-0.1521,0.0093-0.283,0.1108-0.33,0.2558
				c-0.0906,0.2193-0.1323,0.4558-0.122,0.6929c-0.0108,0.2401,0.0299,0.4797,0.1194,0.7028
				c0.0474,0.1821,0.2335,0.2913,0.4156,0.2438c0.1194-0.0311,0.2127-0.1244,0.2438-0.2438
				c0.0901-0.2191,0.1314-0.4553,0.1211-0.692c0.0097-0.2386-0.03-0.4766-0.1165-0.6992
				C73.6264,127.1879,73.522,127.1011,73.3908,127.101z"/>
      </g>
      <path fill="#231F20" d="M74.6586,126.7885h1.1082v0.318h-0.7827v0.6307c0.0251-0.0024,0.0508-0.0036,0.0769-0.0036
			c0.2203-0.008,0.4348,0.0713,0.5968,0.2207c0.1551,0.1449,0.2404,0.3496,0.234,0.5618c0.008,0.2151-0.0762,0.4234-0.2313,0.5727
			c-0.1626,0.1503-0.3783,0.2296-0.5995,0.2206c-0.2056-0.0006-0.408-0.0509-0.59-0.1466v-0.368
			c0.1547,0.1086,0.3379,0.1695,0.5269,0.1751c0.1378,0.0043,0.2724-0.0424,0.3779-0.1313c0.1777-0.1449,0.2043-0.4064,0.0594-0.584
			c-0.0213-0.0262-0.0458-0.0496-0.0728-0.0699c-0.1184-0.0913-0.265-0.1384-0.4145-0.1331
			c-0.0979-0.0064-0.196,0.0058-0.2894,0.0358L74.6586,126.7885z"/>
      <path fill="#231F20" d="M70.4379,128.7644h-1.56l-0.2383,0.5372h-0.3671l1.1288-2.5348h0.487l1.1517,2.5348h-0.3632
			L70.4379,128.7644z M70.3351,128.5244l-0.6817-1.5472l-0.6752,1.5472H70.3351z"/>
    </g>
  </g>
</template>

<script>
export default {
  name: 'sdDialA05',
};
</script>
